import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import Logger from '~/web-frontend-core/devtools/logger';
import { SITE_TYPE } from '~/web-frontend-core/api/const/base';
import { ResultsLiveTablesListener } from '~/web-frontend-core/api/connector/results/live/Tables';
/** Т.к результаты singleton, используем константный ID */
const subscriptionID = 0;
export class ResultsTables extends Subscribtion {
    constructor({ siteType, lng, }) {
        super();
        this.sports = [];
        this.update = this.update.bind(this);
        this.wsListener = new ResultsLiveTablesListener({
            site: siteType || SITE_TYPE.COM,
            lng,
        });
    }
    getData() {
        if (this.sports.length === 0) {
            return null;
        }
        return this.sports;
    }
    clear() {
        this.sports = [];
    }
    //#region WS
    /**
    * Подписка на обновления таблицы live доп.исходов через WS
    */
    listenWS(cfg) {
        if (cfg.language) {
            this.wsListener.setLanguage(cfg.language);
        }
        const logger = Logger.getInstance();
        const onerror = (e) => {
            logger.error(e);
            // this.stopListenWS();
        };
        const onopen = () => {
            // logger.log('[WResultsTables] Соединение открыто');
        };
        const onmessage = this.update;
        this.wsListener.subscribe(Object.assign(Object.assign({}, cfg), { subscriptionID,
            onmessage,
            onerror,
            onopen }));
    }
    update(data) {
        if ('changedScores' in data) {
            this.updateScore(data);
            return;
        }
        this.sports = data.sports;
        this.notify();
    }
    updateScore({ changedScores }) {
        this.sports.forEach(({ championships }) => {
            championships.forEach(({ matches }) => {
                matches
                    .filter(({ id }) => id in changedScores)
                    .forEach((match) => { match.score = changedScores[match.id]; });
            });
        });
        this.notify();
    }
    stopListenWS() {
        this.wsListener.unsubscribe({ subscriptionID });
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/results/live/Tables.js